import React, { Component } from 'react';

import Css from './NavDots.scss';

class NavDots extends Component {
  render() {
    const activePage = this.props.activePage;

    const dots = [...Array(this.props.pageCount)].map((e, i) => {
      return (
        <div
          onClick={e => this.props.click(i)}
          key={i}
          className={
            Css.dot +
            ' ' +
            (activePage === i ? Css.active : '') +
            ' align-items-center d-flex justify-content-center'
          }
        />
      );
    });

    return (
      <div id={'nav-dots'} className={Css['nav-dots']}>
        {dots}
      </div>
    );
  }
}

export default NavDots;



// WEBPACK FOOTER //
// ./src/components/NavDots/NavDots.js